import { useEffect, useRef, useState } from "@wordpress/element";
import { setAutoFreeze } from "immer";

import Settings from "./Settings";
import Preset from "../Preset/Preset";
// import BPlayer from "../../BPlayer";
// import { useStyleRenderer } from "../../../../wp-utils/v1/hooks";
import { dataParser } from "../../../../wp-utils/v1";
// import Watermark from "../../Components/Watermark";
import Styles from "./Styles";

setAutoFreeze(false);

const Edit = (props) => {
  const { attributes, clientId, setAttributes } = props;
  const { uniqueId, presets = [], presetData, presetID, align, source, thumbnail, ...selfAttributes } = attributes;
  const domRef = useRef(null);
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    // create unique id
    setAttributes({ uniqueId: `yt${clientId.substr(0, 8)}` });
  }, []);

  // parse data set to attribute when preset changed
  useEffect(() => {
    const presetData = dataParser(presets?.find((item) => item.id === presetID) || presets?.[0] || {});
    setAttributes({ presetData });
  }, [presetID, presets?.length, presets?.find((item) => item.id === presetID)]);

  // reinitialize player if options changed
  useEffect(() => {
    // console.log(domRef.current?.querySelector("#player"), presetData, attributes);
    if (presetData && selfAttributes) {
      if (player) {
        player?.destroy();
      }
      const newPlayer = new Plyr(domRef.current?.querySelector("#player"), presetData?.preset?.options);
      // new BPlayer(newPlayer, { ...presetData, ...selfAttributes }, { preview: true, destroy: false });
      setPlayer(newPlayer);
    }
  }, [presetData?.preset?.options?.controls || presetData?.preset?.options]);

  // console

  return (
    <>
      <Settings {...props} />
      <Preset {...props} />
      {/* <style>{CSS}</style> */}
      <Styles attributes={attributes} setAttributes={setAttributes} />
      {/* <Watermark uniqueId={uniqueId} watermark={presetData?.preset?.watermark} domRef={domRef} player={player} /> */}
      <div id={uniqueId} className={`ytPlayer ${align} ${props.className}`}>
        <div
          ref={domRef}
          className={`ytWrapper ${presetData?.preset?.hideYoutubeUI ? "hideYoutubeUI" : ""} ${presetData?.preset?.hideControlsWhenPause ? "hideControlsWhenPause" : ""}`}
        >
          <div class="plyr__video-embed" id="player">
            <iframe
              src={`${source}?origin=${window.location.origin}&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`}
              allowfullscreen
              allowtransparency
              allow="autoplay"
            ></iframe>
            <div class="plyr__poster" style={{ backgroundImage: `url(${thumbnail})` }}></div>
            {/* <iframe src="https://www.youtube.com/embed/bTqVqk7FSmY?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1" allowfullscreen allowtransparency allow="autoplay"></iframe> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit;
